import AntdConfigProvider from 'antd/es/config-provider';
import { ComponentProps } from 'react';

const theme: ComponentProps<typeof AntdConfigProvider>['theme'] = {
    // token: {
    //     colorPrimary: '#396fe5',
    //     colorSuccess: '#00d15c',
    //     colorWarning: '#ffa400',
    //     colorError: '#ff3d00',
    //     colorInfo: '#396fe5',
    //     colorBgBase: '#f7f8f9',
    //     colorTextBase: '#000000',
    //     colorBgElevated: '#ffffff',
    //     colorBgLayout: '#ffffff',
    //     colorBorder: '#E6EAEC',
    //     colorBgContainer: '#F7F8F9',
    //     colorText: 'rgba(0,0,0,0.92)',
    //     colorTextTertiary: 'rgba(0,0,0,0.5)',
    //     colorTextQuaternary: 'rgba(0,0,0,0.34)',
    //     colorFillQuaternary: 'rgba(0, 0, 0, 0.02)',
    //     fontSizeLG: 14,
    //     lineHeightLG: 18 / 14,
    //     borderRadiusLG: 6,
    // },
    // components: {
    //     Button: {
    //         colorBgContainer: '#f2f3f5',
    //         colorBorder: 'rgba(0,0,0,0)',
    //         // 设置 box-shadow
    //         controlOutlineWidth: 0,
    //         controlTmpOutline: '0',
    //         controlOutline: '0',
    //         colorErrorOutline: '0',
    //         colorPrimaryHover: '#3F7CFF',
    //         colorTextDisabled: 'rgba(255,255,255,0.60)',
    //         colorBgContainerDisabled: '#8FB2FF',
    //     },
    //     Input: {
    //         colorTextLabel: 'rgba(0,0,0,0.92)',
    //         colorPrimaryHover: '#396FE5',
    //         colorBgContainerDisabled: '#F7F8F9',
    //         controlHeight: 40,
    //     },
    //     Modal: {
    //         borderRadiusLG: 12,
    //         paddingMD: 0,
    //         paddingContentHorizontalLG: 0,
    //     },
    //     Select: {
    //         controlHeight: 40,
    //         colorPrimaryHover: '#396FE5',
    //     },
    //     Table: {
    //         colorTextHeading: 'rgba(0,0,0,0.42)',
    //         colorFillAlter: '#f2f3f5',
    //         colorBgContainer: '#ffffff',
    //         lineHeight: 16 / 14,
    //         colorBorderSecondary: 'rgba(0,0,0,0.08)',
    //     },
    //     Pagination: {
    //         controlHeight: 40,
    //     },
    //     Breadcrumb: {
    //         fontSize: 12,
    //         lineHeight: 17 / 12,
    //     },
    //     Segmented: {
    //         colorBgLayout: '#F2F3F5',
    //         borderRadius: 4,
    //         borderRadiusLG: 6,
    //         colorTextLabel: 'rgba(0,0,0,0.5)',
    //         colorText: '#396FE5',
    //         colorFillSecondary: 'transparent',
    //     },
    //     Form: {
    //         colorTextHeading: 'rgba(0,0,0,0.5)',
    //         controlHeight: 40,
    //     },
    //     DatePicker: {
    //         controlHeight: 40,
    //         colorPrimaryHover: '#396FE5',
    //     },
    //     Drawer: {
    //         padding: 12,
    //         paddingLG: 32,
    //     },
    //     Checkbox: {
    //         colorBorder: 'rgba(0,0,0,0.34)',
    //     },
    //     Radio: {
    //         colorPrimaryActive: '#396FE5',
    //         colorPrimaryHover: '#396FE5',
    //     },
    // },
};

export default theme;
